
import React from 'react';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const Toast = ({}) => {

    return (
        <ToastContainer
            autoClose={3000}
            position='top-right'
            closeOnClick={false}
            pauseOnHover={true}
            hideProgressBar={false}
            stacked={true}
        />

    );
};

export default Toast;
